export default __webpack_public_path__ + "static/media/pantry2-before1.34dd4ccf.jpg";